import { useEffect } from 'react';

import { useDAL } from '@/contexts/useDAL';

import { InProgressScreen } from './inProgressScreen';

export const SetupAccountInProgress = ({ onDone }: { onDone: () => void }) => {
  const dal = useDAL();
  const { body: deployStatus } = dal.onboarding.backupAccount.getDeployStatus({
    refreshInterval: 500,
  });

  useEffect(() => {
    if (deployStatus?.status === 'deployed') {
      onDone();
    }
  }, [deployStatus?.status, onDone]);

  return (
    <InProgressScreen
      title='Getting things ready to move forward'
      description={`We're performing some operations in the background to prepare for the next step. You'll be able to continue as soon as everything is ready.`}
      src='/images/illustrations/onboarding/eon-spaceship.mp4'
      alt={`Deploying Eon's backup account`}
      size='large'
    />
  );
};
